/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Daily_EyebrowInputs */

const en_funnel_ob_daily_eyebrow = /** @type {(inputs: Funnel_Ob_Daily_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your pace`)
};

const es_funnel_ob_daily_eyebrow = /** @type {(inputs: Funnel_Ob_Daily_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca tu ritmo`)
};

/**
* | output |
* | --- |
* | "Set your pace" |
*
* @param {Funnel_Ob_Daily_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_daily_eyebrow = /** @type {((inputs?: Funnel_Ob_Daily_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Daily_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_daily_eyebrow(inputs)
	return en_funnel_ob_daily_eyebrow(inputs)
});